import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "oauth"

  google() {
    this.send("google", {})
  }
}
